import { useEffect } from 'react'
import { applySpec, pipe, path } from 'ramda'
import { useSelector, useDispatch } from '@/hooks/redux'

type NestedContract = Record<string, string>

const formatContracts = (contracts: NestedContract[]) => {
  const format = applySpec({
    listing_contract_id: contract => contract?.id,
    unit_number: contract => contract?.unit?.unit_number,
    full_street_name: contract => contract?.buildings?.full_street_name,
    city: contract => contract?.buildings?.city,
    zip: contract => contract?.buildings?.zip,
    state: contract => contract?.buildings?.state
  })
  return contracts.map(contract => {
    const extra = format(contract)
    return { ...contract, ...extra }
  })
}

const useReviewPadContracts = (enabled = true) => {
  const dispatch = useDispatch()
  const contracts = useSelector(
    pipe(path(['settlements', 'review_pad_contracts', 'contracts']), formatContracts as any)
  )
  useEffect(() => {
    if (!enabled) return
    dispatch.settlements.getReviewPadContracts()
  }, [enabled, dispatch.settlements])
  if (!enabled) return []
  return contracts
}

export default useReviewPadContracts
